import { render, staticRenderFns } from "./Tab0.vue?vue&type=template&id=67b6a8ee&"
import script from "./Tab0.vue?vue&type=script&lang=js&"
export * from "./Tab0.vue?vue&type=script&lang=js&"
import style0 from "./Tab0.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports